import {CardActionArea as MUICardActionArea} from '@mui/material'

export const CardActionArea = MUICardActionArea
